var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x83\x81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M14.208 55.168L19.2 58.624C31.168 51.776 35.648 42.368 35.648 28.736C35.648 28.736 35.648 18.624 35.648 13.632L30.528 14.336C30.528 23.104 30.528 28.864 30.528 28.864C30.528 42.048 25.088 50.048 14.208 55.168Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    d: "M33 13.5C34.5 51 27 49.5 15.5 57.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    d: "M5.63199 32.064V26.752C7.03999 26.88 9.27999 27.072 11.264 27.072H53.376C54.72 27.072 57.088 26.944 58.432 26.816V32.064C57.024 31.936 55.04 31.872 53.44 31.872H11.328C9.27999 31.872 7.16799 31.936 5.63199 32.064Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_2",
    d: "M5.5 29.5H58.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    d: "M11.904 16.32L10.624 11.52C15.424 11.776 25.152 11.52 32.128 10.56C37.952 9.79199 45.44 8.25599 48.576 6.84799L51.968 11.328C50.56 11.712 49.344 12.032 48.384 12.288C44.672 13.184 38.72 14.336 33.6 15.04C26.4889 15.9924 17.7402 16.1889 12.0403 16.3169L11.904 16.32Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_3",
    d: "M51 8.5C43.5 12 27.4353 14.1795 10.5 14",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTi);
export default __webpack_public_path__ + "static/media/ti.246b6dd0334ede52dc310c8cb57a8d13.svg";
export { ForwardRef as ReactComponent };